const [
  rank, brandName, 
  socialMediaIndex, carForumIndex,
  carMediaIndex, soMeIndex,
  productName,
  spread,
  favor,
  participation
] = [{
  title: '排名',
  name: 'rank'
}, {
  title: '品牌名称',
  name: 'brandName'
}, {
  title: '社交媒体指数',
  name: 'social_media_index'
}, {
  title: '汽车论坛指数',
  name: 'car_forum_index'
}, {
  title: '汽车媒体指数',
  name: 'car_media_index'
}, {
  title: 'SO-ME指数',
  name: 'so_me_index'
}, {
  title: '产品名',
  name: 'productName'
}, {
  title: '传播度指数',
  name: 'spread_index'
}, {
  title: '好感度指数',
  name: 'favorable_index'
}, {
  title: '参与度指数',
  name: 'participateIndex'
}]

export const brandColunms = [rank, brandName, socialMediaIndex, carForumIndex, carMediaIndex, soMeIndex]

export const productColunms = [rank, brandName, productName, soMeIndex]

export const customeColunms = [rank, brandName, socialMediaIndex, carForumIndex, soMeIndex]

export const ageColunms = [rank, brandName, spread, favor, participation, soMeIndex]



// WEBPACK FOOTER //
// src/routes/soumi/colunms.js